import { createFileRoute } from "@tanstack/react-router";
import { OnboardingAuthGate } from "@/components/onboarding/OnboardingAuthGate";
import { OnboardingDesign } from "@/components/onboarding/OnboardingDesign";
import { guardWorkspaceAccess } from "@/lib/workspaceGuard";
import { useOnboardingStepEvent } from "@/lib/useOnboardingStepEvent";

export const Route = createFileRoute("/onboarding/$workspaceId/design")({
  ssr: false,
  beforeLoad: guardWorkspaceAccess,
  component: OnboardingDesignRoute,
});

function OnboardingDesignRoute() {
  useOnboardingStepEvent("design");
  const { workspaceId } = Route.useParams();
  return (
    <OnboardingAuthGate>
      <OnboardingDesign workspaceId={workspaceId} />
    </OnboardingAuthGate>
  );
}
